module.exports = __webpack_public_path__ + "static/mh-example-1-b5c35986db9abb82e63aa80f6fe8e941.jpg";